module.exports = __webpack_public_path__ + "static/img/mobile-web-img@w.c816fb8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem/mobile-web-img@w.png
// module id = 1UJH
// module chunks = 0